import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { PayrollItem, PayrollItemCreate, PayrollItemFilter } from '../data/payrollItem';

export function createPayrollItemService(client: AxiosInstance) {
  return createCrudService<PayrollItem, PayrollItemCreate, PayrollItemFilter>(
    client,
    '/hrm/PayrollItem',
    'id',
  );
}

export type PayrollItemService = CrudService<PayrollItem, PayrollItemCreate, PayrollItemFilter>;
